import {
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
    TRACKING_AVAILABLE_PRODUCTS_CABLE,
    TRACKING_PAGE_TYPE,
    TRACKING_FORM_TYPE,
    TRACKING_FORM_SUCCESS_FIBER,
    TRACKING_FORM_SUCCESS_CABLE,
    TRACKING_FORM_FAILED,
    TRACKING_LOGGED_IN,
    TRACKING_NOT_LOGGED_IN,
    ADDITIONAL_CMS_SITE_STRUCTURE,
} from '../../../constant';
import { getLoginData } from '@vfde-fe/sails_core';

/**
 * initTracking
 * @param siteStructure
 */
export const initTracking = () => {
    const loginStatus = getLoginData() ? TRACKING_LOGGED_IN : TRACKING_NOT_LOGGED_IN;
    const siteStructure =  ADDITIONAL_CMS_SITE_STRUCTURE;
    const trackingPayload = {
        pageType: TRACKING_PAGE_TYPE,
        loginStatus: loginStatus,
        siteArea: TRACKING_SITE_AREA_MOBILITY,
        platformType: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        siteStructure: [...siteStructure],
    };

    return {...trackingPayload};
};

/**
 * address found
 * addressArt can be EWA, WiLü or Empty
 */
export const addressFoundTracking = (addressArt: string, technologie: string) => {
    const trackingPayload = initTracking();

    let availableType = '';
    let availableProductsTitle = '';

    if ('Glasfaser' === technologie || '' === technologie) {
        availableProductsTitle = TRACKING_SITE_AREA_MOBILITY;
        availableType = TRACKING_FORM_SUCCESS_FIBER;
    } else {
        availableProductsTitle = TRACKING_AVAILABLE_PRODUCTS_CABLE;
        availableType = TRACKING_FORM_SUCCESS_CABLE;

        const index = trackingPayload.siteStructure.indexOf('Glasfaser');

        if (index !== -1) {
            trackingPayload.siteStructure[index] = 'Kabel-Glasfaser';
        }
    }

    availableType += ' ' + addressArt;
    availableType = availableType.trim();

    trackingPayload.siteStructure.push(TRACKING_FORM_TYPE, availableType);

    const foundTrackingPayload = {
        availableProducts: availableProductsTitle,
    };

    return {
        ...trackingPayload,
        ...foundTrackingPayload,
    };
};

/**
 * addressNotFoundTracking
 * @param siteStructure
 */
export const addressNotFoundTracking = () => {
    const trackingPayload = initTracking();

    trackingPayload.siteStructure.push(TRACKING_FORM_TYPE, TRACKING_FORM_FAILED);

    return trackingPayload;
};
